import { EditButton } from "@pankod/refine-mui";

export default {
  title: "Le mie strutture",
  resource: "strutture-ext",
  canCreate: false,
  metas: { populate: "localizations" },
  dataGridParams: {
    permanentFilter: [{ field: "gestore", operator: "eq", value: "false" }],
  },
  columns: [
    { field: "businessName", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      field: "address",
      headerName: "Indirizzo",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "city",
      headerName: "Città",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 300,
      renderCell: function render(params) {
        return (
          <EditButton recordItemId={params.row.id}>Modifica Planner</EditButton>
        );
      },
    },
  ],
};
